import { render, staticRenderFns } from "./CAxARPxClarificationsPage.vue?vue&type=template&id=290c71c4"
import script from "./CAxARPxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxARPxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxARPxClarificationsPage.vue?vue&type=style&index=0&id=290c71c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports